import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import {FC, memo, useEffect, useMemo} from 'react';

import logo from '../../../assets/logo.png';

import {firstMenu, secondMenu} from '../../../shared/menu.data';

import SidebarMenu from './SidebarMenu/SidebarMenu';

import styles from './Sidebar.module.scss';
import Typography from '@mui/material/Typography';
import {colors} from '../../../shared/colors';
import {useRecoilValue} from 'recoil';
import {authState} from '../../../store/auth/atoms';

import config from '../../../../package.json';
import {checkAuthorities} from '../../../shared/helpers/checkAuthorities';
import {TypeAccountRoles} from '../../../shared/types/user-account.types';
import {IMenuItem} from '../../../shared/types/menu.types';

const filterMenuItemsByRoles = (menu: IMenuItem[], roles: TypeAccountRoles[]) => {
  return menu.filter((item) => {
    if (item.forRoles) {
      return checkAuthorities(
        item.forRoles,
        roles.filter((r) => r !== TypeAccountRoles.VIEWER),
      );
    }
    return item;
  });
};

const Sidebar: FC = memo(() => {
  const {user} = useRecoilValue(authState);

  const firstMenuItems = useMemo(() => {
    return filterMenuItemsByRoles(firstMenu, [...(user?.roles || [])]);
  }, [user]);

  const secondMenuItems = useMemo(() => {
    return filterMenuItemsByRoles(secondMenu, [...(user?.roles || [])]);
  }, [user]);

  return (
    <nav className={styles.nav}>
      <div>
        <div>
          <div className={styles.menuHeader}>
            <img src={logo} alt="Logo" />
            <span>
              <Typography variant="h6" sx={{color: colors['text--primary'], fontWeight: 700}} component="h6">
                Меню
              </Typography>
            </span>
          </div>
          <Stack spacing={2} divider={<Divider orientation="horizontal" />}>
            <SidebarMenu menu={firstMenuItems} />
            <SidebarMenu menu={secondMenuItems} />
          </Stack>
        </div>
      </div>
      {config?.version && (
        <span style={{position: 'absolute', bottom: 0, left: '6px'}}>
          <Typography variant="caption" sx={{color: colors['text--primary']}}>
            v{config.version}
          </Typography>
        </span>
      )}
    </nav>
  );
});

export default Sidebar;
